import { AddToPhotos } from '@mui/icons-material';
import * as Sentry from '@sentry/react';
import { Col, Progress, Row } from 'antd';
import MultiFileUploader from "components/UI/admin/MultifileUploadGallery";
import { useAlert } from 'components/UI/alertSakeBar/alertProvider';
import React, { useEffect, useState } from 'react';
import { FileUploader } from "react-drag-drop-files";
import styled from 'styled-components';
import COLOR from "utils/constants/color";
import { imageUploader } from "utils/methods/imageUploader";
import { IMAGE_FILE_TYPE, UPLOAD_IMAGE_TO_FIREBASE } from "utils/constants/enum"


const ImageContainer = styled.div`
    height: auto;
    flex: 1;
    height:70vh;
`;

const Images = styled.img`
    background-color: ${COLOR.white};
    box-shadow: 0 10px 20px rgba(0,0,0,0.19), 0 6px 6px rgba(0,0,0,0.23);
    max-height: 100%;
    max-width: 100%;
    object-fit: contain;
    border-radius:8px;
`;
const Container = styled.div`
    width: 100%;
    height: 100%;
    display:flex;
    align-item:center;
    justify-content:center;
    position: relative;
    background-color:${p => p.empty ? "rgba(0,0,0,0.1)" : "transparent"}
`;

const Page = styled.div`
    align-items: center;
    color: ${COLOR.black100};
    display: flex;
    flex-direction: row;
    font-size: 14px;
    font-weight: 400;
    white-space: nowrap;
`;

const Input = styled.input`
    background-color: transparent;
    border: 1px dashed gray;
    border-radius: 3px;
    box-shadow: none;
    font-size: inherit;
    font-weight: 400;
    outline: none;
    padding: 0px 2px;
    transition: all 300ms ease;
    width:250px;
`;
const FileUploadArea = styled.div`
    height: 100%;
    border: 1px dashed gray;
    padding: 5px 12px;
    min-height: 50px;
    display: flex;
    flex-direction: column;
    justify-content: center;
`;

const Text = styled.div`
    font-size: 12px;
`;
const Column = styled(Col)`
display: flex;
    justify-content: center;
    align-items: center;
}
`
const ImageWrapper = styled.div`
    border: 1px dashed;
    padding: 10px;
    border-radius: 8px;
    margin-bottom: 15px;
    display: flex;
    flex-direction: column;
    align-items: center;
    background-color: #f9f9f9;
`;

export default function Pages({ src, onChange, description, onChangeDescription, style, hasDescription, pageId, path }) {
      const showAlert = useAlert();
    const [pagePoster, setpagePoster] = useState(src)
    const [loader, setLoader] = useState(false)
    const [loadingMap, setLoadingMap] = useState(0)
    useEffect(() => {
        setpagePoster(src)
    }, [src])
    const handleChange = (file) => {
        const reader = new FileReader();
        reader.readAsDataURL(file);
        uploadToStorage(file, pageId)
        reader.onloadend = function (e) {
            let v = reader.result;
            setpagePoster(v)
            // onChange({ url: v, pageId })
        };
    };
    const uploadToStorage = async (file, index ) => {
        if (file) {
            try {
                showAlert("Uploading..", "info")
                setLoader(true);
                const onProgress = per =>{
                    setLoadingMap(per);
                    setLoader(true);
                }
                const downloadURL = await imageUploader(file, onProgress,UPLOAD_IMAGE_TO_FIREBASE)
                if(downloadURL){
                    setLoader(false);
                    setLoadingMap(0);
                    onChange({ url: downloadURL, pageId: index });
                    showAlert("Uploaded file successfully","success")
                }else{
                    setLoader(false);
                    setLoadingMap(0);
                    showAlert("Error while uploading image.","error")
                }
            } catch (error) {
                Sentry.captureException(`301 Error uploading image: ${error}`);
                console.error("Upload error:", error);
                showAlert("Error while uploading image.","error")
            } finally {
                setLoader(false);
                setLoadingMap(0);
            }
        } else {
            console.log("No file to upload.");
        }
    };
     const onSelectImage = (v, index) => {
        onChange({ url: v, pageId: index });
        setpagePoster(v)
    }
    return (
        <ImageContainer onContextMenu={(e) => { }} style={style}>
            {hasDescription ? <Row style={{ height: 30 }}>
                <Col span={24} style={{ display: "flex", flexDirection: "row" }}>
                    <Page>
                        Description :&nbsp; <Input type="text" value={description || ''} onChange={e => onChangeDescription(e.target.value)} />
                    </Page>
                </Col>
            </Row> : null}
            <ImageWrapper empty={!pagePoster}>
                <Images src={pagePoster} />
                  <MultiFileUploader inModal onSelect={v=>{ onSelectImage(v, pageId) }}/>
                <FileUploader
                    classes={"file-uploader-cover answerFileUploader"}
                    handleChange={handleChange}
                    name="file"
                    types={IMAGE_FILE_TYPE}

                >
                    <FileUploadArea>
                        {loader && <Progress type="line" percent={loadingMap} size={"small"} className={"fileProgress"} showInfo={false} />}
                        <Row className="box box-1" style={{ display: "flex", justifyContent: "space-between" }}>
                            <Column >
                                <AddToPhotos color="primary" />
                            </Column>
                            <Column>
                                <Text>
                                    Upload or drop a file right here
                                </Text>
                            </Column>
                            <Column>
                                <Text>
                                    {IMAGE_FILE_TYPE.join(",")}
                                </Text>
                            </Column>
                        </Row>

                    </FileUploadArea>
                </FileUploader>
            </ImageWrapper>
        </ImageContainer>
    )
}
